import { Grid, RadioGroupInput } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Melding van Buitenlandse Rekeningen bij het CAP (NBB)"
      description="Zijn de wettelijk bepaalde gegevens met betrekking tot alle hierboven vermelde buitenlandse rekeningen bij het CAP (NBB) gemeld?"
      maxWidth={1000}
    >
      <Grid container spacing={4}>
        <RadioGroupInput
          name="report_foreign_accounts_to_cap"
          items={[
            { text: 'ja', value: 'ja' },
            { text: 'nee', value: 'nee' },
          ]}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
